import { stateToHTML } from 'draft-js-export-html'
import { getImageSrc } from './editor-utils'
import inlineStyleFn from './inline-style'
const options = {
  inlineStyleFn,
  blockStyleFn: block => {
    const blockAlignment = block.getData() && block.getData().get('text-align')

    if (blockAlignment) {
      return {
        style: {
          textAlign: blockAlignment.replace('align-', ''),
        },
      }
    }

    return undefined
  },
  entityStyleFn: entity => {
    const entityType = entity.get('type').toLowerCase()

    // console.log('entityType', entityType)
    if (entityType === 'button') {
      const data = entity.getData()
      return {
        element: 'a',
        attributes: {
          className: 'rte-button',
          href: data.link,
          target: data.linkTarget,
        },
        style: data.style,
      }
    }

    if (entityType === 'image') {
      const data = entity.getData()
      return {
        element: 'img',
        attributes: {
          src: getImageSrc(data),
          width: data.width,
        },
      }
    }

    if (entityType === 'merge_tag') {
      return {
        element: 'span',
        attributes: {
          className: 'rich-editor__merge-tag',
        },
      }
    }

    if (entityType === 'link') {
      const data = entity.getData()
      return {
        element: 'a',
        attributes: {
          href: data.url,
          target: '_blank',
        },
      }
    }

    return undefined
  },
}
export default (contentState: Record<string, any>): string =>
  stateToHTML(contentState, options).replace(/>&nbsp;<\/img>/, '/>')
